import { Component, Input, Output, EventEmitter } from "@angular/core";
import { TimeSlot } from "src/app/store/entities";

// Path: src/app/components/buttons/button/button.component.ts
@Component({
    selector: 'mwo-edit-day-schedule',
    templateUrl: './edit-day-schedule.component.html',
    styleUrls: ['./edit-day-schedule.component.scss'],
})
export class EditDayScheduleComponent {

    private _list: TimeSlot[];

    @Input()
    set list(value: TimeSlot[]) {
        this._list = value;
    }

    get list(): TimeSlot[] {
        return this._list;
    }

    currentEditIndex = -1;
    currentDeleteIndex = -1;

    @Output() onEdit = new EventEmitter<number>();

    constructor() { }

    handleEdit(index: number) {
        this.currentEditIndex = index;
        this.currentDeleteIndex = -1;
        this.onEdit.emit(index);
    }

    handleDelete(index: number) {
        this.currentDeleteIndex = index;
        this.currentDeleteIndex = -1;
    }

}
